import React from "react";
import { useHistory } from "react-router-dom";

import "./mobile-offers-style.scss";
import useIsComDomain from "@src/hooks/useIsComDomain";

// Components
import TabBar from '@src/componentsNew/TabBar';
import OfferList from "@src/componentsNew/Offers/OfferList";
import { uiComponentVariables } from "@src/core/config";

import { baseUrl, offersUrl, mobileMainMgsTabUrl } from "@src/app/routes";

const tabItems = [
  { name: 'For You', url: baseUrl },
  { name: 'Offers', url: offersUrl },
  { name: 'MGS', url: mobileMainMgsTabUrl },
];

const MobileOffersPage = () => {
  const history = useHistory();
  const isComDomain = useIsComDomain();

  const handleTabChange = (event, newValue) => {
    history.push(tabItems[newValue].url);
  };

  return (
    <div id="mobile-offers-wrapper">
      <TabBar tabItems={tabItems} selectedTab={1} onTabChange={handleTabChange} />

      <OfferList
        isFindMoreOffers={false}
        uiComponentVariable={isComDomain ? uiComponentVariables.mainOffersCom : uiComponentVariables.mainOffers}
      />
    </div>
  )
};

export default MobileOffersPage;